import moneyIcon from "../assets/dinero.svg";
import educationIcon from "../assets/educacion.svg";
import incomesIcon from "../assets/ingresos-estables.svg";
import otherIcon from "../assets/otro.svg";
import debtsIcon from "../assets/salir-deudas.svg";
import travelIcon from "../assets/viajar.svg";
import housingIcon from "../assets/vivienda.svg";

const getIconByPurpose = (purpose: string | number) => {
  const purposes = {
    30: housingIcon, // Comprar vivienda
    31: educationIcon, // Quiero estudiar
    32: travelIcon, // Quiero viajar
    34: debtsIcon, // Salir de deudas
    35: moneyIcon, // Empezar a ahorrar
    33: incomesIcon, // Ingresos estables
    default: otherIcon
  };
  return purposes[purpose] || purposes.default;
};

export default getIconByPurpose;
